import BaseService from './base.service';

export default class ResourceService extends BaseService {
  getResourceInfo(uuid, token = null, hideContext = false) {
    return this.get(`/resources/${uuid}?hideContext=${hideContext}`, token);
  }
}
